/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".forgot-password-link[_ngcontent-%COMP%]{display:block;padding-bottom:16px;width:100%;text-align:center}"];
export { styles as styles };
